import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Box, Typography } from "@mui/material";
import TeacherNavbar from "./TeacherNavbar"; // Import your TeacherNavbar
import CreatedCourseDetailsTable from "./CreatedCourseDetailsTable"; // Import the table component
import { fetchCreatedCourses } from "../../../redux/Actions/courseCreateActions"; // Import the action
import "./ApprovalStatus.css"; // Import the CSS for this page

const ApprovalStatus = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.user.userId); // Assuming userId is in Redux auth state

  useEffect(() => {
    if (userId) {
      dispatch(fetchCreatedCourses(userId)); // Fetch created courses for this teacher
    }
  }, [dispatch, userId]);
  return (
    <div className="approval-status-layout">
      <TeacherNavbar /> {/* Put it in the routes intsead of repeating it*/}
      <Container className="approval-status-container">
        <Box className="approval-status-content">
          <Typography
            variant="h4"
            gutterBottom
            className="approval-status-title"
          >
            Pending Created Course Status
          </Typography>

          {/* Render the CreatedCourseDetailsTable component */}
          <CreatedCourseDetailsTable />
        </Box>
      </Container>
    </div>
  );
};

export default ApprovalStatus;
